import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F9430 {
  f9430_01: string;   // 員工代號 (PK part 1, 8 chars)
  f9430_02: string;   // 年月 YYYYMM (PK part 2, 6 chars)
  f9430_11: string;   // 備用說明
  f9430_14: number;   // 明細筆數

  // Association
  details?: F9431[];
}

export interface F9431 {
  f9431_01: string;   // 員工代號 (FK)
  f9431_02: string;   // 年月 (FK)
  f9431_03: number;   // 項次序號
  f9431_11: string;   // 薪資代號
  f9431_11a: string;  // 薪資名稱 (denormalized)
  f9431_21: number;   // 薪資金額
  f9431_22: number;   // 備用數量
  f9431_23: string;   // 說明
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW9233ListResponse {
  data: F9430[];
  total: number;
  page: number;
  size: number;
}

export interface PW9233CreateRequest {
  master: Partial<F9430>;
  details: Partial<F9431>[];
}

// ============================================================
// API methods
// ============================================================

export const pw9233Api = {
  async list(page = 1, size = 20): Promise<PW9233ListResponse> {
    const res = await apiClient.get('/api/pw9233', { params: { page, size } });
    return res.data;
  },

  async search(keyword: string): Promise<PW9233ListResponse> {
    const res = await apiClient.get('/api/pw9233/search', { params: { keyword } });
    return res.data;
  },

  /** Composite key: empCode + yearMonth */
  async get(empCode: string, yearMonth: string): Promise<F9430> {
    const res = await apiClient.get(`/api/pw9233/${encodeURIComponent(empCode)}/${encodeURIComponent(yearMonth)}`);
    return res.data;
  },

  async create(data: PW9233CreateRequest): Promise<F9430> {
    const res = await apiClient.post('/api/pw9233', data);
    return res.data;
  },

  /** Composite key: empCode + yearMonth */
  async update(empCode: string, yearMonth: string, data: PW9233CreateRequest): Promise<F9430> {
    const res = await apiClient.put(`/api/pw9233/${encodeURIComponent(empCode)}/${encodeURIComponent(yearMonth)}`, data);
    return res.data;
  },

  /** Composite key: empCode + yearMonth */
  async delete(empCode: string, yearMonth: string): Promise<void> {
    await apiClient.delete(`/api/pw9233/${encodeURIComponent(empCode)}/${encodeURIComponent(yearMonth)}`);
  },

  /** Lookup: employee, department, salaryCode */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9233/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
